import R from 'ramda'

const GOOGLE_ANALYTICS_TRACK_EVENT_ACTION_TYPE = 'GOOGLE_ANALYTICS_TRACK_EVENT'
const GOOGLE_ANALYTICS_TRACK_EVENT_DISPLAY_TYPE = 'Google Analytics Track Event'

const isGoogleAnalyticsTrackEventWidgetAction = R.propEq(
  'type',
  GOOGLE_ANALYTICS_TRACK_EVENT_ACTION_TYPE
)

const convertGoogleAnalyticsTrackEventWidgetActionToFormAction = R.applySpec({
  type: R.always(GOOGLE_ANALYTICS_TRACK_EVENT_DISPLAY_TYPE),
  eventCategory: R.prop('eventCategory'),
  eventAction: R.prop('eventAction'),
  eventLabel: R.prop('eventLabel')
})

export {
  isGoogleAnalyticsTrackEventWidgetAction,
  convertGoogleAnalyticsTrackEventWidgetActionToFormAction
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/widget-to-form/google-analytics-track-event.js